import React, { useState, useCallback, useEffect } from "react";
import { TOOLS } from "./tools.js";
import { ACCOUNTS, ACCOUNT_TYPES } from "./accounts.js";
import { UserPlusIcon } from "@heroicons/react/24/solid";
import axios from 'axios';
import { decodeToken } from "react-jwt";

export function countWords(content) {
  return content.split(' ').filter(word => word !== '').length;
}

// experimental at this point
export function WithHttp(WrappedComponent, url, dataFormatter) {

  return class extends React.Component {

    constructor(props) {
      super(props);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.state = { data: {} };
    }

    async handleSubmit(formData) {

      const formattedFormData = dataFormatter(formData);

      const request = {
        ...formattedFormData,
        // TODO where does the key actually come from?
        //
        //key: appData.account.cfKey // in hopes I can go right to /temp-api eventually
      };

      // setIsLoading(true);

      // TODO find out if we can cut this out and go right to the source
      const response = await axios.post(url, request)
        .then((response) => {

          // responses from the API are always 200 OK
          // need to parse out error(s) if any and/or real data
          // setIsLoading(false);
          // set App state to the data which should merge with the existing data
          // setToolData(responseData);
          return JSON.parse(response.data);
        })
        .catch((error) => {
          // handle error
          // the app cannot do anything without data...
          // this.setState({error: error});
          // console.log(error);
        });

      // setIsLoading(false);
      return response;
    }

    render() {
      return (
        <WrappedComponent data={this.state.data} {...this.props} handleSubmit={this.handleSubmit} inputChange={this.inputChange} />
      );
    }
  }
}

function renderInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

function parseUrlParams() {

  // select the partner
  const query = window.location.search.substring(1);

  const qString = query.split("&");
  const params = { path: window.location.pathname.split("/").filter(x => x.length > 0) };
  qString.forEach((x, i) => {
    if (x) {
      const parts = x.split("=");
      const k = parts[0];
      const v = parts[1];
      params[k] = v;
    }
  });
  return params;
}

function sample(population, k) {
  /*
      Chooses k unique random elements from a population sequence or set.

      Returns a new list containing elements from the population while
      leaving the original population unchanged.  The resulting list is
      in selection order so that all sub-slices will also be valid random
      samples.  This allows raffle winners (the sample) to be partitioned
      into grand prize and second place winners (the subslices).

      Members of the population need not be hashable or unique.  If the
      population contains repeats, then each occurrence is a possible
      selection in the sample.

      To choose a sample in a range of integers, use range as an argument.
      This is especially fast and space efficient for sampling from a
      large population:   sample(range(10000000), 60)

      Sampling without replacement entails tracking either potential
      selections (the pool) in a list or previous selections in a set.

      When the number of selections is small compared to the
      population, then tracking selections is efficient, requiring
      only a small set and an occasional reselection.  For
      a larger number of selections, the pool tracking method is
      preferred since the list takes less space than the
      set and it doesn't suffer from frequent reselections.
    */

  if (!Array.isArray(population)) throw new TypeError("Population must be an array.");
  var n = population.length;
  if (k < 0 || k > n) throw new RangeError("Sample larger than population or is negative");

  var result = new Array(k);
  var setsize = 21; // size of a small set minus size of an empty list

  if (k > 5) setsize += Math.pow(4, Math.ceil(Math.log(k * 3) / Math.log(4)));

  if (n <= setsize) {
    // An n-length list is smaller than a k-length set
    var pool = population.slice();
    for (var i = 0; i < k; i++) {
      // invariant:  non-selected at [0,n-i)
      var j = (Math.random() * (n - i)) | 0;
      result[i] = pool[j];
      pool[j] = pool[n - i - 1]; // move non-selected item into vacancy
    }
  } else {
    var selected = new Set();
    for (var i = 0; i < k; i++) {
      var j = (Math.random() * n) | 0;
      while (selected.has(j)) {
        j = (Math.random() * n) | 0;
      }
      selected.add(j);
      result[i] = population[j];
    }
  }

  return result;
}

const AppDataContext = React.createContext();
AppDataContext.displayName = "AppDataContext";

export function AppDataProvider(props) {

  const [appDataContext, setAppDataContext] = useState(props.value);
  const [paidUserStatus, setPaidUserStatus] = useState(false);


  const updateRecentTools = (toolNames) => {

    setAppDataContext(data => {
      data.user.recentTools = new Set([...toolNames]);

      return { ...data };
    });
  }

  const getRecentTools = () => {
    if (appDataContext.user.recentTools
      && Array.isArray(appDataContext.user.recentTools)
      && appDataContext.user.recentTools.length > 0) {
      return appDataContext.user.recentTools;
    } else {
      return new Set([]);//recentTools;
    }
  };

  // detects paid users versus free trail users
  useEffect(() => {
    if (appDataContext && appDataContext.auth) {
      const { is_main_product_active, is_app_taken_for_free } = decodeToken(appDataContext.auth);
      if (is_main_product_active) {
        setPaidUserStatus(true);
      }
    }
  },[appDataContext]);

  return (
    <AppDataContext.Provider value={{ appDataContext, getRecentTools, updateRecentTools, paidUserStatus }}>
      {props.children}
    </AppDataContext.Provider>
  );
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function prettyCredits(creditsInt) {
  return creditsInt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export { AppDataContext, parseUrlParams, sample, TOOLS, renderInIframe };
